/** Ссылки на внешние площадки Благо. Держим в одном месте: на них ссылаются и хедер, и футер. */
export const YOUTUBE_CHANNEL_URL = 'https://youtube.com/@blagopro';
